import { CAST_AI, EXTERNAL_LINKS } from '@cast/constants';
import { ConfirmationDialogProps, ExternalLink } from '@cast/design-system';

export const getTerraformGuidanceDialogProps = (): ConfirmationDialogProps => ({
  testId: 'terraform-managed-cluster-notice',
  title: `Use Terraform to enable ${CAST_AI}`,
  message: (
    <>
      The cluster was connected using Terraform. Enable {CAST_AI} using the same
      platform.{' '}
      <ExternalLink
        link={EXTERNAL_LINKS.castai_terraform}
        testId="terraform-guidance-dialog-docs-link"
      >
        Open Terraform docs
      </ExternalLink>
    </>
  ),
  onConfirm: () => undefined,
  slotProps: { footer: { endContent: null } },
});
